'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedIncomingMessageAction = undefined;
exports.receivedIncomingMessage = receivedIncomingMessage;

var _reduxActions = require('redux-actions');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _hasNewUnseenMessage = require('../../last-seen/actions/hasNewUnseenMessage');

var _AgentResponderActions = require('../../actions/AgentResponderActions');

var _isActiveOnThread = require('../../selectors/clientSelectors/isActiveOnThread');

var _getIsOpen = require('../../selectors/getIsOpen');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var receivedIncomingMessageAction = exports.receivedIncomingMessageAction = (0, _reduxActions.createAction)(ActionTypes.RECEIVED_INCOMING_MESSAGE, function (_ref) {
  var message = _ref.message,
      channel = _ref.channel,
      responder = _ref.responder,
      shouldNotify = _ref.shouldNotify,
      threadId = _ref.threadId;
  return {
    message: message,
    channel: channel,
    responder: responder,
    shouldNotify: shouldNotify,
    threadId: threadId
  };
});

function receivedIncomingMessage(_ref2) {
  var message = _ref2.message,
      channel = _ref2.channel,
      responder = _ref2.responder,
      shouldNotify = _ref2.shouldNotify,
      threadId = _ref2.threadId;

  return function (dispatch, getState) {
    dispatch(receivedIncomingMessageAction({
      message: message,
      channel: channel,
      responder: responder,
      shouldNotify: shouldNotify,
      threadId: threadId
    }));

    var widgetClosed = !(0, _getIsOpen.getIsOpen)(getState());
    var notActiveOnThread = !(0, _isActiveOnThread.isActiveOnThread)(getState(), threadId);

    var senderType = (0, _commonMessageFormatGetters.getSenderType)(message);
    var senderId = (0, _commonMessageFormatGetters.getSenderId)(message);

    if ((0, _messageTypeComparators.isConversationalMessage)(message) && (widgetClosed || notActiveOnThread) && senderType !== _senderTypes.VISITOR) {
      dispatch((0, _hasNewUnseenMessage.hasNewUnseenMessage)({ channel: channel, threadId: threadId }));
    }

    if (senderType === _senderTypes.AGENT || senderType === _senderTypes.BOT) {
      dispatch((0, _AgentResponderActions.fetchAgentResponderIfNecessary)({ senderId: senderId, senderType: senderType }));
    }
  };
}